import Vue from 'vue'
import Antd from 'ant-design-vue'
import App from './App.vue'
import router from './router'
import i18n from './locales'
import 'ant-design-vue/dist/antd.css'
import request from './utils/request'

Vue.config.productionTip = false

Vue.use(Antd)
Vue.prototype.$request = request

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
